import { render } from "./FinancesPage.vue?vue&type=template&id=bec2b8dc"
import script from "./FinancesPage.vue?vue&type=script&lang=js"
export * from "./FinancesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__